export function getFlightsInsuranceRequestParams(params) {
  return {
    '00N0N00000HDZoG': params === null || params === void 0 ? void 0 : params.fullName,
    '00N0N00000HQyvE': params === null || params === void 0 ? void 0 : params.phoneNumber,
    '00N0N00000GZRrd': params === null || params === void 0 ? void 0 : params.bookingNumber,
    '00N0N00000HDKpR': params === null || params === void 0 ? void 0 : params.contactEmail,
    recordType: '0120N000000wtjk',
    type: 'Flight Insurance',
    subject: 'Flight Insurance Request'
  };
}